import React from 'react';
import CtReviewTable from './table/CtReviewTable';

const ReviewContent: React.FC = () => {
  return <CtReviewTable />;
};

export default ReviewContent;
